import { render, staticRenderFns } from "./DialogPOSAnswersVetable.vue?vue&type=template&id=299c480e"
import script from "./DialogPOSAnswersVetable.vue?vue&type=script&lang=js"
export * from "./DialogPOSAnswersVetable.vue?vue&type=script&lang=js"
import style0 from "./DialogPOSAnswersVetable.vue?vue&type=style&index=0&id=299c480e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports